<template>
  <header>
    <b-row align-v="center" class="headerBackCartMobile" style="height:70px;" :style="{backgroundColor: getCssColor('bg_header')}">
      <b-col cols="2" style="text-align:center;">
        <template v-if="!noIcons">
          <div v-if="!leftAction || leftAction==='back'" @click="searchBackPath()" style="cursor:pointer;" :style="{color: getCssColor('primary_bt')}">
            <font-awesome-icon style="font-size:24px;"  :icon="['fal', 'chevron-left']"/>
          </div>
          <div v-else-if="leftAction && leftAction==='menu'" @click="openSlideMenu()" style="cursor:pointer;" :style="{color: getCssColor('header_icon_color')}">
            <font-awesome-icon style="font-size:24px;"  :icon="['fal', 'bars']"/>
          </div>
        </template>
      </b-col>
      <b-col style="text-align:center;">
        <img :src="$store.getters.getLogo" @click="$router.push({path:'/home'})" alt="logo" class="logoHeaderBackCartMobile"/>
      </b-col>
      <b-col cols="2" style="text-align:center;" >
        <template v-if="!noIcons && !noCart">
          <a href="#/cart" style="position:relative;" class="ico" :style="{color: getCssColor('header_icon_color')}">
            <CartBullet style="top:-15px; right:-8px;"/>
            <font-awesome-icon style="font-size:24px;" :icon="['fal', 'shopping-cart']"/>
          </a>
        </template>
        <template v-if="loginButton">
          <a  @click="$router.push({path:($store.state.user?'/profile':'/login')})" style="position:relative;" class="ico" :style="{color: getCssColor('header_icon_color')}">
            <font-awesome-icon style="font-size:24px;" :icon="['fal', 'user']"/>
          </a>
        </template>
      </b-col>
    </b-row>

    <!-- login modal TODO -->
    <Modal :showModal="modalLogin" :modalHeight="'280'" >
      <div @click="modalLogin = false" style="z-index:19002;position:absolute;top:5px;right:20px;cursor:pointer;width:30px;height:30px;text-align:center;">
        <font-awesome-icon style="font-size:26px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
      </div>
      <div style="width:100%; height:100%;padding:10px;">
        <LoginForm @loggedIn="modalLogin = false"/>
      </div>
    </Modal>

    <!-- menu modal -->
    <div :class="{menuLinksModalOpennedInn:menuLinksModal, menuLinksModalInn:!menuLinksModal}" style="position:fixed;top:0px;z-index:21000;background-color:#ffffff;">
      <b-container>
        <b-row class="headerBackCart" style="height:60px;" :style="{backgroundColor: getCssColor('bg_header')}">
          <b-col cols="2" style="height:60px;line-height:60px;text-align:center;">
            <div @click="menuLinksModal=false" style="cursor:pointer;" :style="{color: getCssColor('primary_bt')}">
              <font-awesome-icon style="font-size:20px;"  :icon="['fal', 'chevron-left']"/>
            </div>
          </b-col>
          <b-col cols="10" style="height:60px;line-height:60px;font-weight:500;font-size: 18px; color: #525962;;">
            MENU
          </b-col>
        </b-row>
        <b-row>
          <MenuLinks />
        </b-row>
      </b-container>
    </div>

  </header>
</template>

<script>
import navigation from '@/mixins/navigation'
import cartMixin from '@/mixins/cartMixin'
import formaters from '@/mixins/formaters'
import colors from '@/mixins/colors'
import CartBullet from '@/components/CartBullet.vue'
import MenuLinks from '@/components/MenuLinks'
import Modal from '@/components/Modal'
import LoginForm from '@/components/LoginForm'

export default {
  props: {
    backToHome: Boolean,
    leftAction: String,
    noIcons: Boolean,
    noCart: Boolean,
    loginButton: Boolean
  },
  data () {
    return {
      menuLinksModal: false,
      modalLogin: false,
      email: null,
      password: null
    }
  },
  components: { CartBullet, MenuLinks, Modal, LoginForm },
  mixins: [navigation, colors, formaters, cartMixin],

  methods: {
    searchBackPath () {
      if (this.backToHome && this.backToHome === true) {
        this.$router.push({path: '/home'})
      } else {
        this.back()
      } 
    },

    openSlideMenu () {
      this.menuLinksModal = true
    }
    
  }
}
</script>

<style lang="scss">

.logoHeaderBackCartMobile {
  max-width: 100px;
  max-height:60px;
  margin-top: auto;
  vertical-align:middle;
}

.headerBackCartMobile {
  border-bottom:1px solid #CDCDCD;
}

.menuLinksModalInn {
    height: 100vh;
    width: 100vw;
    left:-100vw;
    -webkit-transition: left 0.2s linear;
       -moz-transition: left 0.2s linear;
        -ms-transition: left 0.2s linear;
         -o-transition: left 0.2s linear;
            transition: left 0.2s linear;
}

.menuLinksModalOpennedInn {
  height: 100vh;
  width:100vw;
  left:0vw;
  -webkit-transition: left 0.2s linear;
    -moz-transition: left 0.2s linear;
      -ms-transition: left 0.2s linear;
      -o-transition: left 0.2s linear;
          transition: left 0.2s linear;
}

.inputFormLoginModal {
  width: calc(100%);
  font-size:16px;
  height:35px;
  padding-left:30px;
  color: #000000;
  background-color: transparent;
  border-radius:4px;
  border: 1px solid #979797;
}

.imgInputModalIcon {
  position:relative;
  left:5px;
  top:28px;
  font-size:16px;
}
</style>
